// Funciones de validación

export const validateRUT = (rut) => {
  // Remove dots and ensure there's a dash
  if (!rut) return false;

  // Basic format validation
  const rutRegex = /^[0-9]{7,8}-[0-9kK]{1}$/;
  if (!rutRegex.test(rut)) return false;

  // Extract digits and verifier
  const [digits, verifier] = rut.split('-');
  let s = 0;
  let t = 2;

  // Calculate checksum
  for (let i = digits.length - 1; i >= 0; i--) {
    s = s + parseInt(digits.charAt(i)) * t;
    t = t === 7 ? 2 : t + 1;
  }

  const v = 11 - (s % 11);
  const calculatedVerifier = v === 11 ? '0' : v === 10 ? 'K' : v.toString();

  // Compare calculated verifier with provided one
  return calculatedVerifier.toLowerCase() === verifier.toLowerCase();
};

export const validateSSN = (ssn) => {
  // Basic validation for SSN format (XXX-XX-XXXX)
  const ssnRegex = /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/;
  return ssnRegex.test(ssn);
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Detect ID type
export const detectIDType = (id) => {
  if (validateRUT(id)) return 'cl';
  if (validateSSN(id)) return 'us';
  if (validateEmail(id)) return 'email';
  return null;
};